import React from "react";
import { formatDate } from "~/utils/functions/formatDate";
import { Emdash } from "../Punctuation";
import { formatDatetime } from "~/utils/functions/formatDatetime";
import { Tooltip } from "../Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/pro-regular-svg-icons";

// // // //

export function DateDisplay(props: { value: undefined | null | string }) {
    if (!props.value) {
        return <Emdash />;
    }
    return <React.Fragment>{formatDate(new Date(props.value))}</React.Fragment>;
}

export function DatetimeDisplay(props: { value: undefined | null | string }) {
    if (!props.value) {
        return <Emdash />;
    }
    return (
        <React.Fragment>{formatDatetime(new Date(props.value))}</React.Fragment>
    );
}

export function DatetimeCompactDisplay(props: {
    value: undefined | null | string;
}) {
    if (!props.value) {
        return <Emdash />;
    }
    const date = new Date(props.value);
    return (
        <span className="inline-flex items-center">
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="w-max px-2 py-0.5 text-center">
                        <p className="whitespace-nowrap text-xs font-light">
                            {formatDatetime(date)}
                        </p>
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span
                        ref={setTriggerRef}
                        tabIndex={0}
                        className="inline-flex items-center"
                        aria-label="Hover to see full date and time"
                    >
                        {date.toLocaleString("en-us", {
                            year: "2-digit",
                            month: "2-digit",
                            day: "2-digit",
                            timeZone: "utc",
                        })}
                        <span className="ml-1 text-muted-foreground hover:text-muted-foreground-hover">
                            <FontAwesomeIcon icon={faClock} className="h-3" />
                        </span>
                    </span>
                )}
            </Tooltip>
        </span>
    );
}
